import React, { Suspense } from "react";
import { Provider } from "react-redux";
import { store, persistor } from "../_store";
import { PersistGate } from "redux-persist/integration/react";
import { Route, Routes } from "react-router";
import "../ulits/scss/style.scss";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Home from "../pages/Home";
import Home2 from "../pages/Home2";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import Privacy from "../pages/Privecy/index";
import TermsAndCondition from "../pages/TermsAndCondition/index";
import { configs } from "../config";
import { configes } from "../webData";
import { useEffect } from "react";
import { useState } from "react";
import CustomLoader from "../components/CustomeLoader";

export function ChildThemeLayout() {
  const [config, setConfig] = useState({});
  const [isLoding, setIsLoding] = useState(true);

  useEffect(() => {
    getConfigData();
  }, []);

  const getConfigData = () => {
    const query = "?section=socials&section=general";
    fetch(`${configs.localApiUrl}/Configurations/${configes.domainId}${query}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        localStorage.setItem("config", JSON.stringify(data?.Result?.config));
        setConfig(data?.Result?.config);
        setIsLoding(false);
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  return (
    <div className="color-theme">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <Suspense fallback={true}>
            {isLoding && !config ? (
              <CustomLoader />
            ) : (
              <>
                <Header configData={config} />
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/home2" element={<Home2 />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route
                    path="/terms"
                    element={<TermsAndCondition />}
                  />
                </Routes>
                <Footer configData={config} />
              </>
            )}
          </Suspense>
        </PersistGate>
      </Provider>
    </div>
  );
}
